import React, { useState, useEffect, useContext } from 'react';
import { StateContext } from '../../../../../Controllers/context/state';
import StockChartCard from '../StockChartCard/StockChartCard';
import { OpenArrowLeftIcon, OpenArrowRightIcon } from '../../../../Icons/Icons';
import Loading from '../../../LoadingSpinner';
import { SliderContainer, CardsContainer, NavButton, LeftEdge, RightEdge } from './styled-components';
import { checkChartType } from '../StockChart/support';

const StockChartCarousel = ({
    chartMinMax,
	clickedPoint,
	hoveredPoint,
	historicalData,
    setCarouselPlotline,
    setHoverPoint,
    symbol
}) => {

    const [loading, setLoading] = useState(true);
	const [selectedSlide, setSelectedSlide] = useState(0);
	const [slides, setSlides] = useState([]);
	const [isNavigating, setIsNavigating] = useState(false);

    const { setChartInfo, setShowChartInfoWindow,chartType} = useContext(StateContext);




	useEffect(() => {
		if (historicalData == null) {
            setLoading(true);
		}

		const fetchData = async () => {
            setLoading(true);
            const type = checkChartType(chartType);
            
            const filteredData = historicalData.filter(item => {
                if (item.stats) {
                    return item.time_utc >= chartMinMax.min && item.time_utc <= chartMinMax.max;
                }
            }).map(item => ({
                ...item,
                symbol: symbol,  
                aggr: type      
            })).reverse();

            const newSlides = filteredData.reduce((accumulator, currentValue) => {
                accumulator.push([currentValue]);
                return accumulator;
            }, []);

            setSlides(newSlides);
            setSelectedSlide(0);
            setLoading(false);
            setIsNavigating(true);
		};

		if (historicalData != null) {
			fetchData();
		}
	}, [chartMinMax, historicalData, chartType]);

    useEffect(() => {
        if (slides[selectedSlide] && (isNavigating || !hoveredPoint)) {
            const newHoverPoint = slides[selectedSlide][0];
            setCarouselPlotline((prevHoverPoint) => {
                return prevHoverPoint?.time_utc !== newHoverPoint.time_utc ? newHoverPoint : prevHoverPoint;
            });
            setHoverPoint(newHoverPoint);
            setIsNavigating(false);
        } else if (!slides[selectedSlide]) {
            setCarouselPlotline(null);
        }
    }, [selectedSlide, slides]);

	useEffect(() => {
		if (hoveredPoint) {
			slides.forEach((slide, index) => {
				const foundObject = slide.find((item) => item.time_utc === hoveredPoint?.time_utc);
				if (foundObject) {
					setSelectedSlide(index);
				}
			});
		}
	}, [hoveredPoint, slides]);

	useEffect(() => {
		if (clickedPoint) {
			slides.forEach((slide, index) => {
				const clickedCard = slide.find((item) => {
					return item.time_utc === clickedPoint;
				});
				if (clickedCard && clickedCard.symbol === symbol) {
					const type = checkChartType(chartType);
					const enrichedCard = {...clickedCard, symbol: symbol, aggr: type};
					setChartInfo(enrichedCard);
					setShowChartInfoWindow(true);
				}
			});
		}
	}, [clickedPoint, slides, setChartInfo, setShowChartInfoWindow, symbol, chartType]);

	const nextSlide = () => {
		if (selectedSlide < slides.length - 1) {
			setIsNavigating(true);
			setSelectedSlide((prevSelected) => prevSelected + 1);
		}
	};

	const prevSlide = () => {
		if (selectedSlide > 0) {
			setIsNavigating(true);
			setSelectedSlide((prevSelected) => prevSelected - 1);
		}
	};

	if (loading) {
		return (
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Loading />
			</div>
		);
	}

	return (
		<div style={{ padding: '10px 0 0 0' }}>
			<SliderContainer>
				<LeftEdge show={selectedSlide < slides.length - 1}>
					{selectedSlide < slides.length - 1 && (
						<StockChartCard
							cardData={slides[selectedSlide + 1][0]}
							isHovered={false}
							blurred
						/>
					)}
				</LeftEdge>

				<NavButton
					onClick={nextSlide}
					style={{
						visibility:
							selectedSlide === slides.length - 1 ? 'hidden' : 'visible',
					}}
				>
					<OpenArrowLeftIcon />
				</NavButton>

				<CardsContainer>
					{slides[selectedSlide] &&
						slides[selectedSlide].map((card) => (
							<StockChartCard key={card.time_utc} cardData={card} isHovered={true} />
						))}
				</CardsContainer>

				<NavButton
					onClick={prevSlide}
					style={{ visibility: selectedSlide === 0 ? 'hidden' : 'visible' }}
				>
					<OpenArrowRightIcon />
				</NavButton>

				<RightEdge show={selectedSlide > 0}>
					{selectedSlide > 0 && (
						<StockChartCard
							cardData={slides[selectedSlide - 1][0]}
							isHovered={false}
							blurred
						/>
					)}
				</RightEdge>
			</SliderContainer>
		</div>
	);
};

export default StockChartCarousel;
